/* eslint-disable no-nested-ternary */
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import GpsFixed from "@mui/icons-material/GpsFixed";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadgeDot from "components/MDBadgeDot";
import React from "react";
import "react-circular-progressbar/dist/styles.css";
import PropTypes from "prop-types";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";
import { getPointsTextColor } from "utils/HelperFunctions";
import TargetPercentage from "components/TargetPercentage";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import moment from "moment";

function CircularProgressChartForCompany({ teamWiseTotalPerformance, selectedTeam, selectedUser }) {
  const user = useSelector((state) => state.loginUser.loginUserState);
  let concatArray = [];
  let kpiWisePerformance = [];
  let concatUsers = [];

  teamWiseTotalPerformance.forEach((performance) => {
    concatArray = [];
    if (selectedTeam && selectedTeam.teamId === performance.teamId) {
      performance.users.forEach((kpi) => {
        if (selectedUser && selectedUser === kpi.userId) {
          concatArray = concatArray.concat(kpi.totalPerformance);
          kpiWisePerformance = kpiWisePerformance.concat(kpi.kpiWisePerformance);
        }
        if (!selectedUser || selectedUser === 0) {
          concatArray = concatArray.concat(kpi.totalPerformance);
          kpiWisePerformance = kpiWisePerformance.concat(kpi.kpiWisePerformance);
        }
      });
      concatUsers = concatUsers.concat(concatArray);
    }
    if (!selectedTeam) {
      performance.users.forEach((kpi) => {
        concatArray = concatArray.concat(kpi.totalPerformance);
        kpiWisePerformance = kpiWisePerformance.concat(kpi.kpiWisePerformance);
      });
      concatUsers = concatUsers.concat(concatArray);
    }
  });

  const totalAchievedPoints = parseInt(
    concatUsers.reduce((acc, obj) => acc + (obj ? parseInt(obj.points, 10) : 0), 0),
    10
  );

  const totalCompletedKpis = parseInt(
    concatUsers.reduce(
      (acc, obj) => acc + (obj && obj.inputKPIPermission ? parseInt(obj.kpiTargetPoints, 10) : 0),
      0
    ),
    10
  );

  const percentage = (totalAchievedPoints / totalCompletedKpis) * 100;

  const labels = [];
  const data = [];
  const graphKpiColors = [];

  const dataMap = new Map();

  kpiWisePerformance.forEach((_) => {
    if (_?.dateWisePoints?.[0] && _?.KpiActivity?.name) {
      if (dataMap.has(_.KpiActivity.name)) {
        dataMap.set(
          _.KpiActivity.name,
          dataMap.get(_.KpiActivity.name) + parseInt(_?.dateWisePoints?.[0]?.points, 10)
        );
      } else {
        dataMap.set(_.KpiActivity.name, parseInt(_?.dateWisePoints?.[0]?.points, 10));
      }
    }
  });
  dataMap.forEach((value, key) => {
    if (value) {
      if (!labels.includes(key)) {
        labels.push(key);
        data.push(value);
        graphKpiColors.push(generateColorFromString(key));
      }
    }
  });

  return (
    <Card sx={{ height: "320px" }}>
      {/* height value considered same as CircularProgressChart */}
      <MDBox
        sx={{
          width: "100%",
          "& .CircularProgressbar-text": { fontSize: "12px" },
          maxWidth: "400px", // maxWidth value considered same as CircularProgressChart
          "& .big-text": { fontSize: "1rem", fontWeight: "bold" },
        }}
      >
        <Typography variant="h6" color="info" mb={0} display="block" ml="1.5rem" mt="1rem">
          {moment.tz(user.timezone).format("dddd MMM Do")}{" "}
        </Typography>
      </MDBox>
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: "100%",
          overflowWrap: "anywhere",
          "& .CircularProgressbar-text": { fontSize: "12px" },
          maxWidth: "400px",
          margin: "auto",
          p: 2,
          pt: 0,
        }}
      >
        <Grid container alignItems="center">
          <Grid
            item
            xs={5}
            sx={{
              "& .subtext": { fontSize: "12px", paddingBottom: ".6rem" },
              position: "relative",
            }}
          >
            <MDBox
              sx={{
                position: "absolute",
                left: "1.25em",
                height: "3.3em",
                mt: "1.7em",
                borderLeft: "1px dashed #aaa",
              }}
            />
            <MDBox pl={2} sx={{ display: "inline-flex" }}>
              <MDBadgeDot
                color="warning"
                size="lg"
                sx={{
                  p: 0.5,
                  i: {
                    background: getPointsTextColor(totalAchievedPoints, totalCompletedKpis),
                  },
                }}
                badgeContent=""
              />
              <MDBox
                pl={1}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <MDTypography
                  variant="h4"
                  sx={{
                    textAlign: "center",
                    display: "flex",
                    width: "100%",
                    // color: getPointsTextColor(totalAchievedPoints, totalCompletedKpis),
                  }}
                >
                  {totalAchievedPoints}
                  <MDBox
                    sx={{
                      display: "flex",
                      alignItems: "flex-end",
                    }}
                  >
                    <MDTypography
                      variant="subtitle1"
                      sx={{
                        // display: "flex",
                        // alignItems: "flex-end",
                        // mb: 0.1,
                        fontSize: "60%",
                        // color: getPointsTextColor(totalAchievedPoints, totalCompletedKpis),
                      }}
                    >
                      {parseInt(totalAchievedPoints, 10) > 1 ? "pts" : "pt"}
                    </MDTypography>
                  </MDBox>
                </MDTypography>
                <MDTypography variant="caption" color="gray40">
                  achieved
                </MDTypography>
              </MDBox>
            </MDBox>
            <MDBox
              pl={2}
              sx={{
                pt: 5,
                display: "inline-flex",
              }}
            >
              <MDBox
                sx={{
                  display: "flex",
                  alignItems: "center",
                  ml: "-1px",
                  mr: "4px",
                }}
              >
                <GpsFixed
                  sx={{
                    p: 0.2,
                  }}
                />
              </MDBox>
              <MDBox
                pl={1}
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <MDTypography
                  variant="h4"
                  sx={{
                    textAlign: "center",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  {totalCompletedKpis}
                  <MDTypography
                    variant="subtitle1"
                    component="span"
                    sx={{
                      display: "flex",
                      alignItems: "flex-end",
                      mb: 0.1,
                      fontSize: "60%",
                    }}
                  >
                    {parseInt(totalCompletedKpis, 10) > 1 ? "pts" : "pt"}
                  </MDTypography>
                </MDTypography>
                <MDTypography variant="caption" color="gray40">
                  daily target
                </MDTypography>
              </MDBox>
            </MDBox>
          </Grid>
          <Grid item xs={7} p={2}>
            {/* <UserKpisDonutChart labels={labels} data={data} colors={graphKpiColors} /> */}
            <TargetPercentage percentage={percentage} width="100%" height="100%" strokeWidth="8" />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default CircularProgressChartForCompany;

CircularProgressChartForCompany.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  teamWiseTotalPerformance: PropTypes.array.isRequired,
};
